import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import "../src/Css/custom.css";
import Routing from './Routes/Routing';

function App() {
  return (
    <>
      <Routing/>
    </>
  );
}

export default App;